import React from 'react'
import { GlobalStyles } from '../theme/GlobalStyles'

export const BasePage: React.FC = ({ children }) => <>{children}</>
